import { render } from "./TableHeader.vue?vue&type=template&id=5998db6d&scoped=true"
import script from "./TableHeader.vue?vue&type=script&lang=js"
export * from "./TableHeader.vue?vue&type=script&lang=js"

import "./TableHeader.vue?vue&type=style&index=0&id=5998db6d&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5998db6d"]])

export default __exports__